// Mirrors the backend CONFIGURABLE_FIELDS labels
// (app/services/visitor_field_config_service.py) so the check-in and invite
// forms can name a missing required field the same way the server would.
export const VISITOR_FIELD_LABELS: Record<string, string> = {
  phone: "Phone number",
  company: "Company",
  email: "Email",
  expected_exit: "Expected exit time",
  notes: "Notes",
  photo: "Visitor photo",
  id_document: "ID document",
  id_number: "ID number",
  laptop: "Laptop details",
};

/**
 * Given the required-field keys and a {key: present} map of what the form has,
 * return the labels of the required fields that are still missing. Only keys
 * present in `provided` are checked (each form supplies its own fields).
 */
export function missingRequiredLabels(
  required: string[],
  provided: Record<string, boolean>,
): string[] {
  return required
    .filter((key) => key in provided && !provided[key])
    .map((key) => VISITOR_FIELD_LABELS[key] ?? key);
}
